export const convertExtraFields = (extraFields) => {
    if (!extraFields) return []

    try {
      // Parse if it's a JSON string
      let parsedFields = extraFields
      if (typeof extraFields === 'string') {
        parsedFields = JSON.parse(extraFields)
      }

      // If it's not an object, return empty array
      if (typeof parsedFields !== 'object' || Array.isArray(parsedFields)) {
        return []
      }

      // Convert each key-value pair to the required format
      return Object.entries(parsedFields).map(([key, value]) => ({
        showable: [
          {
            in: "workstation",
            format: "both"
          }
        ],
        [key]: value
      }))
    } catch (error) {
      console.error("Error converting extraFields:", error)
      return []
    }
}